const IDLE = 0;
const WAITING = 1;
const PLAYING = 2;
const COMPLETE = 3;

const getBGState = (state,result) => {
    switch ( state ) {
      case PLAYING:
        return 'active';
      case COMPLETE:
        return (result==='vvv'||result==='hhh'||result==='bbb') ? 'win' : 'active';
      default: // IDLE, WAITING
        return 'idle';
    }
}


export default function Background( {state,result} ){
  
  const getBGState = () => {
    if (state===PLAYING) {
      if (!result || result.length===0) return '';
      if (result.indexOf('-')>-1) return 'spinning';
      return 'spun';
    } else if (state===COMPLETE) {
      if (result==='vvv'||result==='hhh'||result==='bbb') return 'win';
      return 'spun';
    }
    return '';
  }
    return (
        <div className={`bg ${getBGState()}`}>
            <div className="gradient" />
            <div className="overlay" />
            <div className="texture" />
        </div>
    ); 
}